<template>
    <div class="card">
        <div class="card-header p-2">
            <div class="row">
                <div class="col-md-10 d-flex align-items-center">
                    <strong>{{ 'Partners > User Status' }}</strong>
                </div>
                <div class="col-md-2">
                    <goback></goback>
                </div>
            </div>
        </div>
        <table class="table table-bordered app-inner" style="table-layout: fixed;">
            <tr>
                <div class="p-2">
                    <form action="" class="form-horizontal form-cs-n">
                        <div class="table-responsive scrollbar app p-2" v-dragscroll="true">
                            <table class="tbl table table-bordered app-inner mb-0" style="font-size: 12px;">
                                <thead v-if="tableFields.length > 0">
                                    <tr>
                                        <th class="text-center p-1">Index</th>
                                        <th class="align-middle p-1" v-for="(lblObj, lIdx) in tableFields">
                                            {{ lblObj.title }}</th>
                                        <th class="text-center p-1" style="width: 50px;"></th>
                                    </tr>
                                </thead>
                                <tbody v-if="tableFields.length > 0">
                                    <tr v-for="(row, index, key) in clientList" v-bind:key="'row' + row + index">
                                        <td class="text-center p-1">{{ index + 1 }}</td>
                                        <td class="p-1" v-for="(fieldObj, ind) in tableFields"
                                            v-bind:key="ind + '-td-' + index + key" style="width: 100%;">
                                            <span>
                                                {{ row[fieldObj.field] }}
                                            </span>
                                        </td>
                                        <td>
                                            <a class="btn btn-sm btn-small btn-primary"
                                                style="margin: 1px 4px; padding: 3px 7px;"
                                                @click="gotoPageHandler(row)"><i title="Edit user"
                                                    class="fa fa-edit cwhite"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot v-if="clientList.length === 0">
                                    <tr>
                                        <td :colspan="tableFields.length">
                                            <div class="alert alert-danger" role="alert">No data found!
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <!-- </tr> -->
                        <!-- </table> -->
                    </form>
                </div>
            </tr>
        </table>
    </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
//import SimpleVueValidation from "simple-vue-validator";
//var Validator = SimpleVueValidation.Validator;
export default {
    components: {},
    name: "UserStatus",
    mixins: [commonMixins],
    created() {
        this.fetchClientList();
    },
    data() {
        return {
            errors: [],
            tableFields: [
                { title: "Name", field: "name" },
                { title: "Email", field: "email" },
                { title: "Mobile", field: "mobile" },
                { title: "Date of Birth", field: "dob" },
                { title: "Holding Type", field: "holding_type" },
                { title: "Nominee Status", field: "nominee_status" },
                { title: "KYC Status", field: "kyc_status" },
                { title: "Address", field: "address" },
                { title: "PAN", field: "pan" },
                { title: "Gender", field: "gender" },
                { title: "TAX Status", field: "tax_status" },
                { title: "TAX Status Individual", field: "tax_status_individual" },
                { title: "Profile Status", field: "profile_status" },
                { title: "Work", field: "work" },
                { title: "Income", field: "income" },
                { title: "Bank", field: "bank" },
                { title: "Risk Profile", field: "risk_profile" },
                { title: "Family", field: "family" },
                { title: "Nominee", field: "nominee" },
                { title: "Partner Name", field: "partner_name" },
                { title: "Partner Code", field: "partner_code" },
                { title: "Action", field: "action" },
            ],
            clientList: [],
            //selectedEditItem: { name: "", phone: "", email: "", whatsapp: "", "_id": "", "user_id": "" },
        };
    },
    /* validators: {
        'selectedEditItem.name': function (value) {
            return Validator.value(value).required('Name is required');
        },
        'selectedEditItem.phone': function (value) {
            return Validator.value(value)
                .required('Phone number is required')
                .regex(/^\+91\d{10}$/, 'Phone number must be valid with country code')
            //.regex(/^\+?[1-9]\d{9,14}$/, 'Phone number must be valid with country code');
        },
        'selectedEditItem.email': function (value) {
            return Validator.value(value).required('Email is required').email();
        },
        'selectedEditItem.whatsapp': function (value) {
            return Validator.value(value)
                .required('WhatsApp number is required')
                .regex(/^\+91\d{10}$/, 'WhatsApp number must be valid with country code');
        },
    }, */
    methods: {
        /* Validator() {
            return Validator.create();
        }, */
        /*  clearForm() {
             this.selectedEditItem = {
                 name: "",
                 phone: "",
                 email: "",
                 whatsapp: "",
                 _id: "",
                 user_id: ""
             };
             this.selectedEditItem = {}
             this.error = [];
             this.validation.reset();
         }, */
        /* closeEditContactModal() {
            console.log('this', this.editContactOpen);
            //this.clearForm();
            // this.selectedEditItem = { name: "", phone: "", email: "", whatsapp: "", "_id": "", "user_id": "" };
            this.editContactOpen = false;
        }, */
        /* editCompany(select, index) {
            console.log('>>> editCompany', select, index);
            this.selectedEditIndex = index;
            //this.selectedEditItem = { name: "", phone: "", email: "", whatsapp: "", "_id": "", "user_id": "" };
            const deepClone = JSON.parse(JSON.stringify(select));
            this.selectedEditItem = deepClone;
            this.editContactOpen = true;
        }, */
        gotoPageHandler(row) {
            console.log('row::: ', row.user_id)
            //acl/edit-user/169
            this.$router.push({
                name: "edit-user",
                params: { id: row.user_id }
            });
        },
        submitHandler() {
            let self = this;
            /* this.$validate(["selectedEditItem.name", "selectedEditItem.email", "selectedEditItem.phone", "selectedEditItem.whatsapp"]).then(success => {
                console.log('on success >>>' + success)
                if (success) {

                    console.log('self.selectedEditItem >>>', self.selectedEditItem);
                    http.post("/frontend/contacts/update", self.selectedEditItem, function (
                        error,
                        response
                    ) {
                        if (!error) {
                            console.log("response >>>", response);
                            if (response.responseType === "success") {
                                self.$toastr.success(response.msg, "", {});
                            } else {
                                self.$toastr.error(response.msg, "", {});
                                self.errors = response.msg;
                            }
                            //self.clearForm();
                            self.editContactOpen = false;
                        } else {
                            console.log("error", error);
                        }
                    });
                } else {
                    console.log('not-success', this.validation)
                }
            }) */
        },
        fetchClientList() {
            let self = this;
            http.post("frontend/client-details-list/get", {}, (error, response) => {
                console.log('fetchClientList:::', response);
                if (response.status === 'success') {
                    console.log('>>> response::: ', response);
                    self.clientList = response.data;
                }
            });
        },
    }
}
</script>
<style scoped>
.tbl.table {
    table-layout: auto !important;
    /* Let browser calculate widths */
    width: auto !important;
    /* No forced full-width unless content needs it */
}

.tbl.table th,
.tbl.table td {
    white-space: nowrap;
    /* Prevent content wrapping */
    width: auto !important;
    /* Let each column decide its own width */
}

.tab-border {
    border: 1px solid #c3c3c3;
}

.cat-compo {
    padding: 0 10rem;
}

/* -------- */
.gallery-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
    padding: 20px;
}

.thumbnail-scroll {
    max-height: 70vh;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
    padding-right: 10px;
}

.thumb-card {
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.2s;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    color: white;
}

.thumb-card:hover {
    transform: scale(1.03);
}

.thumbnail {
    width: 100%;
    height: 140px;
    object-fit: cover;
}

.thumb-card-body {
    padding: 10px;
}

.title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 4px;
}

.source {
    font-size: 12px;
    color: #aaa;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    max-width: 90vw;
    max-height: 90vh;
    text-align: center;
    position: relative;
    width: fit-content;
}

.modal-img {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
}

.modal-title {
    font-weight: bold;
    margin-top: 10px;
}

.modal-source {
    color: gray;
    font-size: 14px;
}

.close-btn {
    position: absolute;
    top: 8px;
    right: 12px;
    font-size: 24px;
    cursor: pointer;
}

/* Nav Button */
.card-actions {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}

.btn {
    padding: 4px 10px;
    font-size: 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    color: white;
}

.btn.edit {
    background-color: #007bff;
}

.btn.mail {
    background-color: #ffffff;
    border: 1px solid #00bd3a;
}

.btn.delete {
    background-color: #dc3545;
}

.custom-table {
    width: 100%;
    border-collapse: collapse;
}

.custom-table thead,
.custom-table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.custom-table tbody {
    display: block;
    /* height: 165px; */
    overflow-y: auto;
}

.btn-edit {
    padding: 2px 5px;
    font-size: 14px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    /* color: white; */
}
</style>


// WEBPACK FOOTER //
// src/views/partners/UserStatus.vue